"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactIntl = require("react-intl");
var _isBefore = _interopRequireDefault(require("date-fns/isBefore"));
var _isValid = _interopRequireDefault(require("date-fns/isValid"));
var _startOfDay = _interopRequireDefault(require("date-fns/startOfDay"));
var _endOfDay = _interopRequireDefault(require("date-fns/endOfDay"));
var _startOfMonth = _interopRequireDefault(require("date-fns/startOfMonth"));
var _subDays = _interopRequireDefault(require("date-fns/subDays"));
var _endOfMonth = _interopRequireDefault(require("date-fns/endOfMonth"));
var _subMonths = _interopRequireDefault(require("date-fns/subMonths"));
var _startOfHour = _interopRequireDefault(require("date-fns/startOfHour"));
var _parse = _interopRequireDefault(require("date-fns/parse"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _enUS = _interopRequireDefault(require("date-fns/locale/en-US"));
var _constants = require("../../constants");
var _AuInput = _interopRequireDefault(require("./AuInput"));
var _AuButton = _interopRequireDefault(require("./AuButton"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _AuDropDown = _interopRequireDefault(require("./AuDropDown"));
var _AuDayPicker = _interopRequireDefault(require("./AuDayPicker"));
var _timezone = require("../../utils/timezone");
var _context, _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11, _context12, _context13, _context14, _context15, _context16; // import moment from 'moment-timezone';
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "au_date_range-module__container___UDxOh",
  "dropdown": "au_date_range-module__dropdown___AdPzs",
  "selection": "au_date_range-module__selection___mmfrO",
  "options": "au_date_range-module__options___a2DWT",
  "desktoponly": "au_date_range-module__desktoponly___HwMcf",
  "xbtn": "au_date_range-module__xbtn___jwIy4",
  "daypicker": "au_date_range-module__daypicker___JRtXZ",
  "wrapper": "au_date_range-module__wrapper___NEpli",
  "legend": "au_date_range-module__legend___HoZDL",
  "legendentry": "au_date_range-module__legendentry___k9vSf",
  "controls": "au_date_range-module__controls___x2HwB",
  "left": "au_date_range-module__left___JvCfv",
  "right": "au_date_range-module__right___gVjBG",
  "input": "au_date_range-module__input___TKuEi",
  "btn": "au_date_range-module__btn___hAh65"
};
const DATEPICKER_NUMBER_OF_MONTHS = 3;
/**
 * See section Localized formats for details -
 *  https://momentjs.com/docs/#/displaying/format/
 *
 * Momentjs localizable formats, based on client's locale:
 *  "l" - M/D/YYYY, D/M/YYYY, YYYY/M/D, YYYY-M-D, D-M-YYYY, D.M.YYYY
 *  "L" - MM/DD/YYYY, DD/MM/YYYY, YYYY/MM/DD, YYYY-MM-DD, DD-MM-YYYY, DD.MM.YYYY
 *
 */
// const DATEPICKER_ALLOWED_FORMAT = [
//   DATETIME_FORMAT_DATE, 'l', 'L'
// ];

const defaultRanges = [{
  key: '1d',
  displayId: 'au.dateRange.lastNhours',
  value: 24
}, {
  key: '7d',
  displayId: 'au.dateRange.lastNdays',
  value: 7
}, {
  key: '30d',
  displayId: 'au.dateRange.lastNdays',
  value: 30
}, {
  key: 'prev_month',
  displayId: 'au.dateRange.prevMonth'
}, {
  key: 'custom',
  displayId: 'au.dateRange.custom',
  className: styles.desktoponly
}];
class AuDateRange extends _react.default.Component {
  static propTypes = {
    className: T.string,
    timezone: T.string,
    ranges: T.arrayOf(T.shape({
      key: T.string.isRequired,
      value: T.number,
      handler: T.func,
      displayId: T.string,
      displayString: T.string,
      className: T.string
    })),
    legend: T.object,
    position: T.oneOf(['left', 'right']),
    excludeToday: T.bool,
    showLegend: T.bool,
    fromMonth: T.instanceOf(Date),
    toMonth: T.instanceOf(Date),
    numberOfMonths: T.number,
    onChange: T.func
  };
  static defaultProps = {
    locale: _enUS.default,
    initialRange: '30d',
    // timezone: moment.tz.guess(),
    timezone: (0, _timezone.getUserTimeZone)(),
    ranges: defaultRanges,
    position: 'left',
    excludeToday: false,
    showLegend: true,
    numberOfMonths: DATEPICKER_NUMBER_OF_MONTHS,
    onChange: _constants.NOOP
  };
  constructor(props) {
    super(props);
    const range = props.initialRange;
    const {
      from,
      to
    } = this.getDatesByRange(range);
    this.state = {
      from,
      to,
      range,
      inputs: {
        from,
        to
      },
      errors: {}
    };
    this.dropdownOptions = this.generateDropDownOptions();
  }
  componentDidMount() {
    this.applyChanges();
  }
  componentWillUnmount() {
    window.removeEventListener('click', this.handleOnOutsideClick);
  }
  handleOnOutsideClick = (0, _bind.default)(_context = this.handleOnOutsideClick).call(_context, this);
  handleOnOutsideClick() {
    const {
      showDayPicker,
      prevRange
    } = this.state;
    if (showDayPicker) {
      const {
        from,
        to
      } = this.getDatesByRange(prevRange);
      this.setState({
        showDayPicker: false,
        range: prevRange,
        from,
        to
      });
    }
    window.removeEventListener('click', this.handleOnOutsideClick);
  }
  handleDropdownChange = (0, _bind.default)(_context2 = this.handleDropdownChange).call(_context2, this);
  handleDropdownChange(range) {
    const {
      from,
      to
    } = this.getDatesByRange(range);
    const isCustomRange = range === 'custom';
    const update = {
      range,
      showDayPicker: isCustomRange
    };
    if (from && to) {
      update['to'] = to;
      update['from'] = from;
      update['inputs'] = {
        from,
        to
      };
    }
    this.setState(prevState => ({
      ...update,
      prevRange: prevState.range
    }), isCustomRange ? _constants.NOOP : this.applyChanges);
    if (isCustomRange) {
      (0, _setTimeout2.default)(() => window.addEventListener('click', this.handleOnOutsideClick));
    }
  }
  handleDayClick = (0, _bind.default)(_context3 = this.handleDayClick).call(_context3, this);
  handleDayClick(date) {
    const {
      from,
      inputs
    } = this.state;
    const newState = {};
    let field = !inputs.from || inputs.to ? 'from' : 'to';

    // if (field === 'to' && moment(date).isBefore(from)) {
    if (field === 'to' && (0, _isBefore.default)(date, from)) {
      field = 'from';
    }
    if (field === 'from') {
      newState['to'] = undefined;
      // date = moment(date).startOf('date').toDate();
      date = (0, _startOfDay.default)(date);
    } else {
      // date = moment(date).endOf('date').toDate();
      date = (0, _endOfDay.default)(date);
    }
    newState[field] = date;
    this.setState(prevState => ({
      ...prevState,
      ...newState,
      inputs: {
        ...prevState.inputs,
        ...newState
      },
      enterTo: undefined
    }), this.validateDates);
    if (field === 'from') {
      this.to.focus();
    }
  }
  handleDayMouseEnter = (0, _bind.default)(_context4 = this.handleDayMouseEnter).call(_context4, this);
  handleDayMouseEnter(date) {
    const {
      from,
      to
    } = this.state;
    // if (from && !to && moment(date).isSameOrAfter(from)) {
    if (from && !to && !(0, _isBefore.default)(date, from)) {
      this.setState({
        enterTo: date
      });
    }
  }
  handleDayMouseLeave = (0, _bind.default)(_context5 = this.handleDayMouseLeave).call(_context5, this);
  handleDayMouseLeave() {
    if (this.state.enterTo) {
      this.setState({
        enterTo: undefined
      });
    }
  }
  handleOnFocus = (0, _bind.default)(_context6 = this.handleOnFocus).call(_context6, this);
  handleOnFocus(field) {
    this.setState({
      focused: field
    });
  }
  handleOnBlur = (0, _bind.default)(_context7 = this.handleOnBlur).call(_context7, this);
  handleOnBlur() {
    this.setState({
      focused: undefined
    }, this.validateDates);
  }

  /**
   * Validator function to check that:
   *  - dates are not empty;
   *  - dates has a valid format;
   *  - "from" date doesn't exceed "to" date;
   *  - both dates are within a specified range;
   *
   * @param  {Boolean} allowEmpty If True - empty considered a valid case.
   * @return {Object}     Return object containing field name and error.
   */
  validateDates = (0, _bind.default)(_context8 = this.validateDates).call(_context8, this);
  validateDates(allowEmpty = true) {
    const {
      numberOfMonths,
      fromMonth,
      toMonth,
      excludeToday
    } = this.props;
    const {
      inputs,
      range
    } = this.state;
    const {
      from,
      to
    } = inputs;
    const newState = {};
    for (let [field, value] of (0, _entries.default)(inputs)) {
      if (!value && allowEmpty) continue;

      // let isValidDate = moment(value, DATEPICKER_ALLOWED_FORMAT, true).isValid();
      let isValidDate = (0, _isValid.default)(value);
      newState[field] = isValidDate ? undefined : {
        fieldDisplayId: `au.dateRange.${field}`,
        errDisplayId: 'au.dateRange.invalidDate'
      };
    }
    if (inputs.from && !newState.from) {
      // const minDate = fromMonth || moment().subtract(numberOfMonths-1, 'months').startOf('month').toDate();
      const minDate = fromMonth || (0, _startOfMonth.default)((0, _subMonths.default)(new Date(), numberOfMonths - 1));
      if (inputs.from < minDate) {
        newState.from = {
          fieldDisplayId: 'au.dateRange.from',
          errDisplayId: 'au.dateRange.invalidDate'
        };
      }
    }
    if (range == 'custom' && inputs.to && !newState.to) {
      const maxDate = toMonth || (
      // excludeToday ? moment().startOf('date').toDate() : moment().endOf('date').toDate()
      excludeToday ? (0, _startOfDay.default)(new Date()) : (0, _endOfDay.default)(new Date()));
      if (inputs.to > maxDate || inputs.from && inputs.from > inputs.to) {
        newState.to = {
          fieldDisplayId: 'au.dateRange.to',
          errDisplayId: 'au.dateRange.invalidDate'
        };
      }
    }
    this.setState({
      from: newState.from ? undefined : from,
      to: newState.to ? undefined : to,
      errors: newState
    });
    return newState;
  }
  handleInputChange = (0, _bind.default)(_context9 = this.handleInputChange).call(_context9, this);
  handleInputChange(e) {
    const {
      name,
      value
    } = e.target;
    let day;
    // const day = moment(value, DATEPICKER_ALLOWED_FORMAT, true);

    if ((0, _isValid.default)(value)) {
      day = (0, _parse.default)(value, _constants.DATETIME_FORMAT_DATE);
    }
    if ((0, _trim.default)(value).call(value) === '' || !day) {
      this.setState(prevState => ({
        inputs: {
          ...prevState.inputs,
          [name]: value
        }
      }));
      return;
    }

    // const date = name === 'from'
    //              ? day.startOf('date').toDate()
    //              : day.endOf('date').toDate();
    const date = name === 'from' ? (0, _startOfDay.default)(day) : (0, _endOfDay.default)(day);
    this.setState(prevState => ({
      inputs: {
        ...prevState.inputs,
        [name]: date
      },
      [name]: date
    }), this.validateDates);
  }
  handleKeyDown = (0, _bind.default)(_context10 = this.handleKeyDown).call(_context10, this);
  handleKeyDown(e) {
    const {
      name
    } = e.target;

    // catching "Enter" key
    if (e.key === _constants.ENTER_KEY) {
      const invalidDates = this.validateDates(false);
      if (name === 'from') {
        if (!invalidDates.from) {
          this.to.focus();
        }
      } else if (!invalidDates.to) {
        this.to.blur();
      }
    }
  }
  applyChanges = (0, _bind.default)(_context11 = this.applyChanges).call(_context11, this);
  applyChanges() {
    const {
      from,
      to,
      range
    } = this.state;
    const invalidDates = this.validateDates(false);
    if (!invalidDates.from && !invalidDates.to) {
      this.setState({
        showDayPicker: false
      });
      if (from && to) {
        this.props.onChange(from, to, range);
      }
    }
  }
  generateDropDownOptions = (0, _bind.default)(_context12 = this.generateDropDownOptions).call(_context12, this);
  generateDropDownOptions() {
    const {
      ranges,
      intl
    } = this.props;
    const options = {};
    (0, _forEach.default)(ranges).call(ranges, rangeProps => {
      options[rangeProps.key] = {
        displayString: intl.formatMessage({
          id: rangeProps.displayId
        }, {
          value: rangeProps.value
        }),
        className: rangeProps.className
      };
    });
    return options;
  }
  getDatesByRange = (0, _bind.default)(_context13 = this.getDatesByRange).call(_context13, this);
  getDatesByRange(range) {
    const {
      excludeToday
    } = this.props;
    let from;
    let to;
    switch (range) {
      case '1d':
        // last 24 hours
        // from = moment().subtract(1, 'days').startOf('hour').toDate();
        // to = moment().startOf('hour').toDate();
        from = (0, _startOfHour.default)((0, _subDays.default)(new Date(), 1));
        to = (0, _startOfHour.default)(new Date());
        break;
      case '7d':
        // last 7 days (including or excluding today)
        // from = moment().subtract(excludeToday ? 7 : 6, 'days').startOf('date').toDate();
        // to = moment().subtract(excludeToday ? 1 : 0, 'days').endOf('date').toDate();
        from = (0, _startOfDay.default)((0, _subDays.default)(new Date(), excludeToday ? 7 : 6));
        to = (0, _endOfDay.default)((0, _subDays.default)(new Date(), excludeToday ? 1 : 0));
        break;
      case '30d':
        // last 30 days (including or excluding today)
        // from = moment().subtract(excludeToday ? 30 : 29, 'days').startOf('date').toDate();
        // to = moment().subtract(excludeToday ? 1 : 0, 'days').endOf('date').toDate();
        from = (0, _startOfDay.default)((0, _subDays.default)(new Date(), excludeToday ? 7 : 6));
        to = (0, _endOfDay.default)((0, _subDays.default)(new Date(), excludeToday ? 1 : 0));
        break;
      case 'prev_month':
        // previous month
        // from = moment().subtract(1, 'months').startOf('month').startOf('date').toDate();
        // to = moment().subtract(1, 'months').endOf('month').endOf('date').toDate();
        from = (0, _startOfMonth.default)((0, _subMonths.default)(new Date(), 1));
        to = (0, _endOfMonth.default)((0, _subMonths.default)(new Date(), 1));
        break;
      case 'custom':
        if (excludeToday) {
          // const today    = moment().startOf('date');
          // const prevFrom = moment(this.state.from);
          // const prevTo   = moment(this.state.to);
          const today = (0, _startOfDay.default)(new Date());
          const prevFrom = this.state.from;
          const prevTo = this.state.to;

          // from = prevFrom.isSameOrAfter(today) ? prevFrom.subtract(1, 'days').toDate() : prevFrom.toDate();
          // to   = prevTo.isSameOrAfter(today) ? prevTo.subtract(1, 'days').toDate() : prevTo.toDate();
          from = !(0, _isBefore.default)(prevFrom, today) ? (0, _subDays.default)(prevFrom, 1) : prevFrom;
          to = !(0, _isBefore.default)(prevTo, today) ? (0, _subDays.default)(prevTo, 1) : prevTo;
        }
        break;
      default:
        break;
    }
    return {
      from,
      to
    };
  }
  getModifiers = (0, _bind.default)(_context14 = this.getModifiers).call(_context14, this);
  getModifiers() {
    const {
      from,
      to
    } = this.state;
    const {
      modifiers
    } = this.props;
    return (0, _assign.default)({
      start: from,
      end: to
    }, modifiers);
  }
  getSelectedDays = (0, _bind.default)(_context15 = this.getSelectedDays).call(_context15, this);
  getSelectedDays() {
    const {
      from,
      to,
      enterTo
    } = this.state;
    return [from, {
      from,
      to: to || enterTo
    }];
  }
  getDisablesDays = (0, _bind.default)(_context16 = this.getDisablesDays).call(_context16, this);
  getDisablesDays() {
    const {
      excludeToday
    } = this.props;
    const {
      from,
      focused
    } = this.state;
    return {
      before: focused === 'to' ? from : undefined,
      // after: moment().subtract(excludeToday ? 1 : 0, 'days').toDate()
      after: (0, _subDays.default)(new Date(), excludeToday ? 1 : 0)
    };
  }
  render() {
    const {
      className,
      numberOfMonths,
      showLegend,
      legend,
      modifiers,
      position,
      intl
    } = this.props;
    const {
      inputs,
      errors,
      range,
      showDayPicker
    } = this.state;
    const {
      from,
      to
    } = inputs;

    // const fromIsValidDate = moment(from, DATEPICKER_ALLOWED_FORMAT, true).isValid();
    // const toIsValidDate   = moment(to, DATEPICKER_ALLOWED_FORMAT, true).isValid();
    const fromIsValidDate = (0, _isValid.default)(from);
    const toIsValidDate = (0, _isValid.default)(to);

    // const fromMonth = this.props.fromMonth || moment().subtract(numberOfMonths-1, 'months').startOf('month').toDate();
    // const toMonth   = this.props.toMonth || moment().endOf('month').toDate();
    const fromMonth = this.props.fromMonth || (0, _startOfMonth.default)((0, _subMonths.default)(new Date(), numberOfMonths - 1));
    const toMonth = this.props.toMonth || (0, _endOfMonth.default)(new Date());
    const legendEntries = [];
    if (showLegend && modifiers) {
      for (let [name] of (0, _entries.default)(modifiers)) {
        var _context17;
        if ((0, _includes.default)(_context17 = ['from', 'to']).call(_context17, name)) continue;
        if (!legend.hasOwnProperty(name)) continue;
        legendEntries.push( /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
          key: 'legend_entry_' + name,
          displayId: legend[name],
          className: (0, _classnames.default)(styles.legendentry, `DayPicker-Day--${name}`)
        }));
      }
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, className)
    }, /*#__PURE__*/_react.default.createElement(_AuDropDown.default, {
      className: styles.dropdown,
      selectionClassName: styles.selection,
      optionsClassName: styles.options,
      selection: range,
      selectOption: this.handleDropdownChange,
      options: this.dropdownOptions
    }), showDayPicker && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.wrapper, styles[position]),
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "javascript:void(0)",
      className: styles.xbtn,
      onClick: this.handleOnOutsideClick
    }), /*#__PURE__*/_react.default.createElement(_AuDayPicker.default
    // ref={el => this.daypicker = el}
    , {
      className: styles.daypicker,
      fromMonth: fromMonth,
      toMonth: toMonth,
      locale: this.locale,
      modifiers: this.getModifiers(),
      selectedDays: this.getSelectedDays(),
      disabledDays: this.getDisablesDays(),
      numberOfMonths: numberOfMonths,
      onDayClick: this.handleDayClick,
      onDayMouseEnter: this.handleDayMouseEnter,
      onDayMouseLeave: this.handleDayMouseLeave
    }), Boolean(legendEntries.length) && /*#__PURE__*/_react.default.createElement("ul", {
      className: styles.legend
    }, legendEntries), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.controls
    }, /*#__PURE__*/_react.default.createElement(_AuInput.default, {
      type: "text",
      name: "from",
      showError: Boolean(errors.from),
      error: errors.from
      // value={fromIsValidDate ? moment(from).format(DATETIME_FORMAT_DATE) : from}
      ,
      value: fromIsValidDate ? (0, _format.default)(from, _constants.DATETIME_FORMAT_DATE) : from,
      className: styles.input,
      placeholder: intl.formatMessage({
        id: 'au.dateRange.from'
      }),
      onMount: el => this.from = el,
      onFocus: () => this.handleOnFocus('from'),
      onBlur: this.handleOnBlur,
      onChange: this.handleInputChange,
      onKeyDown: this.handleKeyDown
    }), /*#__PURE__*/_react.default.createElement(_AuInput.default, {
      type: "text",
      name: "to",
      showError: Boolean(errors.to),
      error: errors.to
      // value={toIsValidDate ? moment(to).format(DATETIME_FORMAT_DATE) : to}
      ,
      value: toIsValidDate ? (0, _format.default)(to, _constants.DATETIME_FORMAT_DATE) : to,
      placeholder: intl.formatMessage({
        id: 'au.dateRange.to'
      }),
      className: styles.input,
      onMount: el => this.to = el,
      onFocus: () => this.handleOnFocus('to'),
      onBlur: this.handleOnBlur,
      onChange: this.handleInputChange,
      onKeyDown: this.handleKeyDown
    }), /*#__PURE__*/_react.default.createElement(_AuButton.default, {
      type: "primary",
      className: styles.btn,
      displayId: "au.dateRange.apply",
      onClick: this.applyChanges
    }))));
  }
}
var _default = exports.default = (0, _reactIntl.injectIntl)(AuDateRange);